import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";

const useStyles = makeStyles(theme => ({
  popoverPaper: {
    borderRadius: "20px",
    padding: "5px 12px",
    margin: "0",
    boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.15)",
  },

  popoverText: {
    fontStyle: "italic",
    fontSize: "1.6rem",
  },
}));

const CopyIcon = props => {
  const { text = "ID", value } = props;
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event, value) => {
    setAnchorEl(event.currentTarget);

    navigator.clipboard.writeText(value).then(
      () => {
        console.log(`${text} copied: `, value);
      },
      () => alert(`Sorry, ${text} could not be copied`),
    );
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `${text}-popover` : undefined;

  return (
    <Fragment>
      <IconButton
        aria-label={`copy ${text}`}
        classes={{ root: classes.copy }}
        onClick={event => handleClick(event, value)}
      >
        <FileCopyOutlinedIcon />
      </IconButton>
      <Popover
        id={id}
        classes={{ root: classes.popoverText, paper: classes.popoverPaper }}
        open={open}
        anchorEl={anchorEl}
        onClose={closePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {text} copied
      </Popover>
    </Fragment>
  );
};

export default CopyIcon;
